const SUCCESS_NOTIFICATION_TYPE = 'success';
const ERROR_NOTIFICATION_TYPE = 'error';

export const createSuccessNotification = (message) => {
  return { type: SUCCESS_NOTIFICATION_TYPE, text: message };
};

export const createErrorNotification = (message) => {
  return { type: ERROR_NOTIFICATION_TYPE, text: message };
};